// extracted by mini-css-extract-plugin
export var backdropBlur = "_gq-0";
export var contentCard = "_gq-5";
export var frame = "_gq-2";
export var image = "_gq-4";
export var imagePane = "_gq-3";
export var modal = "_gq-1";